<template>
  <ValidationProvider
    tag="div"
    :rules="rulesObject"
    :name="label"
    :vid="label + '-' + $id()"
    v-slot="{ errors }"
    v-show="show"
    :class="{
      'f-col-span-2': true,
      'sm:f-col-span-1': !singleColumn,
    }"
  >
    <BaseInputGroup
      :for="id"
      :label="label + (isRequired ? '*' : '')"
      :error="getFirstError(errors)"
      :single-column="singleColumn"
    >
      <template slot="input">
        <BaseInput
          lazy=""
          :id="id"
          :name="name"
          :type="type"
          :error="getFirstError(errors)"
          :placeholder="placeholder"
          :autocomplete="autocomplete"
          v-model="value"
          @input="update"
          :aria-invalid="errors.length > 0 ? 'true' : 'false'"
          :aria-describedby="errors.length > 0 ? `${id}-error` : null"
          :aria-required="isRequired.toString()"
        />
      </template>

      <template slot="error">
        <p
          id="${id}-error"
          v-if="errors.length"
          class="f-text-xs f-text-red-600 f-mb-0 f-mt-1"
        >
          {{ getFirstError(errors) }}
        </p>
      </template>
    </BaseInputGroup>
  </ValidationProvider>
</template>

<script lang="ts">
import InputValidationMixin from "@/components/Form/Basic/Inputs/InputValidationMixin";
import mixins from "vue-typed-mixins";
import { ValidationProvider } from "vee-validate";
import BaseInputGroup from "@/components/Form/Basic/Inputs/BaseInputGroup.vue";
import BaseInput from "@/components/Form/Basic/Inputs/BaseInput.vue";

export default mixins(InputValidationMixin).extend({
  name: "DefaultInput",

  components: {
    BaseInput,
    BaseInputGroup,
    ValidationProvider,
  },

  props: {
    orderIntentData: {
      type: String,
      required: false,
    },
    showInputInFullForm: {
      type: Boolean,
      required: true,
    },
    showInput: {
      type: Boolean,
      required: true,
    },
    isFullForm: {
      type: Boolean,
      required: true,
    },
    rules: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    singleColumn: {
      type: Boolean,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      required: true,
    },
    autocomplete: {
      type: String,
      default: "",
    },
  },

  data(): { oldValue: string | null } {
    return {
      oldValue: null,
    };
  },

  computed: {
    rulesObject(): object {
      return this.show ? this.rules : {};
    },

    show(): boolean {
      if (this.isFullForm && this.showInputInFullForm) {
        return !(this.name === "ic_dph" && !this.showInput);
      }

      return this.showInput;
    },

    id(): string {
      return this.$id(this.name);
    },

    isRequired(): boolean {
      return (
        this.rules.hasOwnProperty("required") && Boolean(this.rules.required)
      );
    },
  },

  methods: {
    update(value: string | null): void {
      if (this.oldValue === value) {
        return;
      }

      if (value === "") {
        value = null;
      }

      this.oldValue = value;
      this.$emit("input", { [this.name]: value });
    },

    updateOrderIntentValue() {
      if (typeof this.orderIntentData === "undefined") {
        return;
      }

      if (this.orderIntentData === null || this.orderIntentData === "") {
        return;
      }

      this.value = this.orderIntentData;
    },
  },

  watch: {
    show(newShowValue: boolean, oldShowValue: boolean): void {
      if (newShowValue === oldShowValue) {
        return;
      }

      let value = this.value;

      if (!this.show) {
        value = null;
      }

      this.update(value);
    },
  },

  mounted(): void {
    if (!this.queryParam) {
      return;
    }

    this.loadDataFromQuery();

    if (this.show) {
      this.update(this.value);
    }

    this.updateOrderIntentValue();
  },
});
</script>
